export const API_URL = 'https://myblogbackend-phgi.onrender.com'